import { faComet, faGhost } from "@fortawesome/duotone-light-svg-icons"
import { faPause } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"
import { useId } from "react"

import useCoachingGroup from "../../hooks/useCoachingGroup"
import { CoachingGroup } from "../../types"
import Tooltip from "../tooltip/Tooltip"

const ClientTag = ({ coachingGroup }: { coachingGroup: CoachingGroup }) => {
  const { isInactive, isNew, isReactivated, isPaused, subscriptionResumeDate } =
    useCoachingGroup(coachingGroup)
  const tooltipId = useId()

  if (isPaused) {
    return (
      <>
        <div
          data-tooltip-id={tooltipId}
          className="w-6 h-6 max-w-6 max-h-6 bg-red-100 rounded-md flex items-center justify-center"
        >
          <FontAwesomeIcon icon={faPause} color={JoonUIColor.semantic.alert} />
        </div>
        <Tooltip id={tooltipId}>
          <Typography
            variant="bodyXSmallBold"
            color={JoonUIColor.text.inverted}
          >
            Paused until {subscriptionResumeDate}
          </Typography>
        </Tooltip>
      </>
    )
  }

  if (isInactive) {
    return (
      <>
        <div
          data-tooltip-id={tooltipId}
          className="w-6 h-6 max-w-6 max-h-6 bg-red-100 rounded-md flex items-center justify-center"
        >
          <FontAwesomeIcon icon={faGhost} color={JoonUIColor.semantic.alert} />
        </div>
        <Tooltip id={tooltipId}>
          <Typography
            variant="bodyXSmallBold"
            color={JoonUIColor.text.inverted}
          >
            Inactive
          </Typography>
        </Tooltip>
      </>
    )
  }

  if (isNew) {
    return (
      <div className="p-1 bg-indigo-100 rounded-md flex items-center justify-center">
        <Typography
          variant="bodyXSmallBold"
          color={JoonUIColor.text.primaryAccent}
        >
          NEW
        </Typography>
      </div>
    )
  }

  if (isReactivated) {
    return (
      <div className="p-1 bg-viridian-100 rounded-md flex items-center justify-center gap-1">
        <FontAwesomeIcon icon={faComet} color={JoonUIColor.semantic.success} />
        <Typography
          variant="bodyXSmallBold"
          color={JoonUIColor.semantic.success}
          className="whitespace-nowrap"
        >
          RE-ENGAGED
        </Typography>
      </div>
    )
  }
  return null
}

export default ClientTag
